import React from "react";
import PropTypes from "prop-types";
import { CTAButtonWrapper } from "./ctaButtonWrapper";
import LoadingDots from "./CTAButtonDotsAnimationWrapper";

const CTAButton = props => {
  const {
    onClickFunc,
    title,
    trackingInfo,
    type,
    color,
    variant,
    hoverColor,
    dataTestId,
    isLoading,
    isPremiumButton,
    width,
    height
  } = props;

  const trackingInfoLocal = trackingInfo
    ? Object.assign({}, trackingInfo, { dataLabel: type })
    : Object.assign({}, trackingInfo, {
        dataCategory: "default",
        dataAction: "click",
        dataLabel: type
      });

  return (
    <CTAButtonWrapper
      onClick={onClickFunc}
      data-category={trackingInfoLocal.dataCategory}
      data-action={trackingInfoLocal.dataAction}
      data-label={trackingInfoLocal.dataLabel}
      color={color}
      isPremiumButton={isPremiumButton}
      variant={variant}
      hoverColor={hoverColor}
      data-testid={dataTestId}
      width={width}
      height={height}
    >
      {isLoading ? <LoadingDots /> : title}
    </CTAButtonWrapper>
  );
};

CTAButton.propTypes = {
  onClickFunc: PropTypes.func,
  title: PropTypes.string,
  trackingInfo: PropTypes.object,
  type: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
  hoverColor: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  isLoading: PropTypes.bool,
  isPremiumButton: PropTypes.bool
};
export default React.memo(CTAButton);
